import { render, staticRenderFns } from "./DashboardAllImprovements.vue?vue&type=template&id=667548d4&scoped=true&lang=pug&"
import script from "./DashboardAllImprovements.vue?vue&type=script&lang=js&"
export * from "./DashboardAllImprovements.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAllImprovements.vue?vue&type=style&index=0&id=667548d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667548d4",
  null
  
)

export default component.exports